import { makeStyles } from '@material-ui/core/styles';
import { get } from 'lodash';
import { pxToRem } from '../../../../styles/themes/vad/constants';

export default makeStyles(theme => ({
  '@global': {
    '.breadcrumbWrapper': {
      '& + .mediaWrapper': {
        '& + .listingPageWrapper': {
          paddingTop: pxToRem(51),
          marginTop: 0,
        }
      },
      '& + .listingPageWrapper': {
        paddingTop: pxToRem(51),
        marginTop: 0,
      }
    },
  },
  root: {
    marginTop: pxToRem(44),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      marginBottom: pxToRem(44),
    },
  },
  pageHeadingWrapper: {

    backgroundColor: (params) => get(params, 'backgroundColor', ''),
    backgroundImage: (params) => `url(/-/media/${get(params, 'bgImage', '')})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',

    paddingTop: pxToRem(44),
    paddingBottom: pxToRem(16),
    ...theme.mixins.paddingLeft(pxToRem(24)),
    ...theme.mixins.paddingRight(pxToRem(24)),

    [theme.breakpoints.up('lg')]: {
      paddingTop: pxToRem(66),
      paddingBottom: pxToRem(37),
      ...theme.mixins.paddingLeft(pxToRem(88)),
      ...theme.mixins.paddingRight(pxToRem(90.3))
    }
  },
  eventListingLogoWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    '& img': {
      top: pxToRem(-16),
      position: 'relative',
      objectFit: 'contain',
    },
  },
  headingTitle: {
    color: (params) => get(params, 'textColor', ''),
    '& h1': {
      ...theme.palette.common.ellipsis(2),
    }
  },
  imageWrapper: {
    position: 'relative',
    height: '73px',
    width: '200px',
    [theme.breakpoints.up('xl')]: {
      width: '262px',
    },
    [theme.breakpoints.down('md')]: {
      paddingBottom: 0,
      display: 'none'
    },
  },
  breadcrumbs: {
    [theme.breakpoints.down('md')]: {
      '& li:nth-last-child(2)': {
        display: 'none',
      },
    },
    '& ol': {
      margin: 0,
      display: 'flex',
      padding: 0,
      flexWrap: 'wrap',
      listStyle: 'none',
      alignItems: 'center',
    },
    '& .MuiBreadcrumbs-separator': {
      display: 'initial',
      marginLeft: '8px',
      marginRight: '8px',
      userSelect: 'none',
      color: (params) => get(params, 'textColor', ''),
    },
  },
  breadcrumbLink: {
    color: 'inherit',
    textDecoration: 'none',
    '&:hover': {
      color: theme.mixins.AbuDhabiOrange(),
    },
  },
  lastBreadcrumb: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'inline',
      color: (params) => get(params, 'textColor', theme.palette.text.tertiary),
    },
  },
}));
